import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById, getUserByRef } from "../models/UserFunctions.js";
import {
  getOrgById,
  getOrgByRef,
  transformInvitesToTable,
  transformPaymentsToTable,
} from "../models/OrgFunctions.js";
import Row from "../layout/Row.js";
import Column from "../layout/Column.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import Icon1 from "../icons/Icon.js";
import MLTFGPT2 from "../textfields/MLTFGPT2.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";
import modifyMaster from "../api/modify/modifyMaster.js";
import InconButton from "../buttons/IconButton.js";
import sendInvite from "../api/send/sendInvite.js";
import { flutterColorToHex } from "../config/theme.js";
import MemberModal from "../modals/MemberModal.js";
import Modal1 from "../modals/Modal1.js";
import MemberColorModal from "../modals/MemberColorModal.js";
import { useAppContext } from "../config/AppContext.js";
import createNewMember from "../api/create/createNewMember.js";
import {
  getArrayDocDataByRef,
  getDateFromFlutter,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getRefFromId,
  listenCollection,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";
import { Switch } from "@mui/material";
import TextField2 from "../textfields/TextField2.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import DataGridFull from "../tables/DataGridFull.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import SearchBarInvoices from "../textfields/SearchBarInvoices.js";
import SearchBarPayments from "../textfields/SearchBarPayments.js";
import initiatePayment from "../api/folder/initiatePayment.js";
import moment from "moment";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import PaymentsTabs from "../tabs/PayementsTabs.js";
import SmallSpinner from "../loading/SmallSpinner.js";
import TabGPT from "../tabs/TabGPT.js";
import EmptyDisplay1 from "../modals/EmptyDisplay1.js";
import Gleap from "gleap";
import { Spin } from "antd";
import DataGridGPT2 from "../tables/DataGridGPT2.js";
import { valueNanCheck } from "./home/MasterStats.js";
import SearchAlgolia from "../textfields/SearchAlgolia.js";
import { queryCollectionAlgolia } from "../models/AlgoliaFunctions.js";
import updateDocApi from "../api/database/updateDocApi.js";

const Payments = ({ userData, orgData, navigateWorkspace, workspaceData }) => {
  const { currentUser, loading } = useAuth();

  const { enqueueSnackbar } = useSnackbar();
  const [payments_per_month, setPayments_per_month] = useState([]);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [payments, setPayments] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [columns, setColumns] = useState([]);
  const [activetab, setActivetab] = useState("current");
  const [loadingRows, setLoadingRows] = useState(true);

  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);

  const [loadingData, setLoadingData] = useState(null);
  const [loadingSelection, setLoadingSelection] = useState("");
  const [tabs = [], setTabs] = useState([
    {
      label: "Paiements en cours",
      id: "current",
    },
    {
      label: "Paiements finalisés",
      id: "archived",
    },
  ]);

  const handleSelectionModelChange = (selectionModel) => {
    setSelectionModel(selectionModel);
  };

  const tabContent = [<span></span>, <span></span>, <span></span>];

  const [selectionModel, setSelectionModel] = useState([]);

  // Fonction pour afficher les messages Snackbar
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const refreshPayments = async (data) => {
    setPayments(data);
  };

  // Fonction pour récupérer les données de l'organisation
  const handleFetchData = async () => {
    if (userData) {
      try {
        let paymentsMaster = [];
        let paymentsParnters = [];

        if (!workspaceData) {
          const filtersMaster = [
            {
              field: "master_id",
              operator: "==",
              value: orgData.id,
            },
            {
              field: "initiation_seconds",
              operator: ">",
              value: 0,
            },
          ];

          paymentsMaster =
            (await queryCollection("payment", filtersMaster)) || []; // Récupère les paiements
        } else {
          const filtersPartner = [
            {
              field: "admins_id",
              operator: "array-contains",
              value: orgData.id,
            },
            {
              field: "initiation_seconds",
              operator: ">",
              value: 0,
            },
          ];

          paymentsParnters =
            (await queryCollection("payment", filtersPartner)) || []; // Récupère les paiements
        }

        const allPayments = [...paymentsMaster, ...paymentsParnters]; // Combine les paiements
        const options = allPayments.map((payment) => ({
          value: payment.id,
          label: payment.nom || "",
        }));
        setOptions(options);
        setPayments(allPayments); // Met à jour l'état avec les paiements
        handleFetchPaymentsStats(
          orgData,
          allPayments,
          // last 12 months
          new Date(new Date().getFullYear(), new Date().getMonth() - 11, 1)
        ); // Récupère les statistiques des paiements

        setTimeout(() => {
          setLoadingRows(false);
        }, 500);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };

  const handleGoFolder = (e, folder_id) => {
    e.stopPropagation();
    navigateWorkspace("/folder/" + folder_id);
  };

  const handleTabChange = (newTab) => {
    setActivetab(newTab);
    const { rows, columns } = transformPaymentsToTable(
      payments,
      SendAgain,
      CancelPayment,
      searchValue,
      loadingData,
      handleGoFolder,
      newTab
    );
    setRows(rows);
    setColumns(columns);
  };

  const CancelPayment = async (e, ref) => {
    e.stopPropagation();
    await updateDocDataFieldApi(ref, "state", "error", prefix);
    handleClickVariant("Paiement annulé", "success");
  };

  const SendAgain = async (e, value) => {
    setLoadingData(value);
    e.stopPropagation();
    const token = await getOrRefreshFirebaseToken(); // Fetch Firebase token
    let payment = await getDocDataById("payment", value);
    let delay = moment().unix() - payment.initiation_seconds;
    if (delay < 3600) {
      handleClickVariant(
        "Il vous reste " +
          Math.floor((3600 - delay) / 60) +
          " minutes avant de pouvoir renvoyer la demande de paiement",
        "error"
      );
      setLoadingData(null);
      return;
    }

    let history_events = payment.history_events || [];
    history_events.push({
      date: getFlutterTime(),
      name: "Demande de paiement renvoyée",
    });
    await updateDocApi(
      payment.ref,
      {
        history_events: history_events,
        state: "initiated",
        initiation_seconds: moment().unix(),
      },
      prefix
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "reglement.state",
      "initialised",
      prefix
    );

    await initiatePayment(payment.folder_ref.id, value, token, prefix);
    handleClickVariant("Demande de paiement envoyée avec succès", "success");
    await handleFetchData();
    setLoadingData(null);
  };

  // Function to navigateWorkspace to a client by ID
  const gotoPaymentName = async (algolia_payment) => {
    navigateWorkspace("/payment/" + algolia_payment.value);
  };

  const [algoliaResults, setAlgoliaResults] = useState([]);

  const handleQuerySearch = async (searchTerm) => {
    let folders_filters = [];
    let customFilter = null;

    if (!workspaceData) {
      folders_filters = [
        {
          field: "master_id",
          operator: "==",
          value: orgData.id,
        },
      ];
    } else {
      // For workspace data, use custom filter string for complex OR logic
      customFilter = `master_id:${workspaceData.master_id}`;
    }

    try {
      let results = await queryCollectionAlgolia(
        "payment", // indexName
        folders_filters, // filtersArr (only used if customFilter is null)
        searchTerm, // searchTerm
        50, // limit

        customFilter // customFilterOverride
      );

      setAlgoliaResults(results);
      setSearchValue(searchTerm);
    } catch (error) {
      console.error("Error in handleQuerySearch:", error);
      setAlgoliaResults([]);
    }
  };

  const handleFetchPaymentsStats = async (orgData, payments, firstDayYear) => {
    // I want to get the number of folders created per month
    let pay_per_month = [];

    let max_amount_count = 0;

    let anchor_date = firstDayYear;
    // loop through each of the last 12 months and get the number of folders created
    for (let i = 0; i < 12; i++) {
      let firstDay = new Date(
        anchor_date.getFullYear(),
        anchor_date.getMonth() + i,
        1
      );
      let lastDay = new Date(
        anchor_date.getFullYear(),
        anchor_date.getMonth() + i + 1,
        0
      );

      let associated_payments = payments.filter((pay) => {
        let pay_date = getDateFromFlutter(
          pay.paid_date ||
            getFlutterTimeFromSeconds(pay.initiation_seconds || 0)
        );
        return (
          pay_date >= firstDay && pay_date <= lastDay && pay.state === "paid"
        );
      });

      let associated_payments_no_bridge = associated_payments.filter(
        (pay) => pay.bridge?.status !== "ACSC"
      );

      pay_per_month.push({
        month: firstDay.toLocaleString("default", { month: "long" }),
        year: firstDay.getFullYear(),
        bridge_count: associated_payments
          .filter((pay) => pay.bridge?.status === "ACSC")
          .reduce((acc, pay) => {
            if (pay.amount) {
              return acc + pay.amount;
            }
            return acc;
          }, 0),

        count: associated_payments.reduce((acc, pay) => {
          if (pay.amount) {
            return acc + pay.amount;
          }
          return acc;
        }, 0),
      });
    }
    max_amount_count = Math.max(...pay_per_month.map((item) => item.count));
    pay_per_month = pay_per_month.map((item) => {
      return {
        ...item,
        height: Math.round((item.count / max_amount_count) * 25),
        bridge_height: Math.round((item.bridge_count / max_amount_count) * 25),
      };
    });

    setPayments_per_month(pay_per_month);
  };
  const id = orgData.id;
  useEffect(() => {
    handleFetchData(); // Récupère les données de l'organisation lorsque le composant est monté
  }, [currentUser]);

  useEffect(() => {
    if (payments) {
      const { rows, columns } = transformPaymentsToTable(
        payments,
        SendAgain,
        CancelPayment,
        searchValue,
        loadingData,
        handleGoFolder,
        activetab
      );
      setRows(rows);
      setColumns(columns);
    }
  }, [payments, searchValue]);

  if (loading || !currentUser || loadingRows) {
    return (
      <div className="h-full w-full pl-4 flex items-center justify-center flex-col gap-2">
        <SmallSpinner></SmallSpinner>
      </div>
    ); // Affiche un message de chargement
  }

  return (
    <div className="w-full h-full pr-4 flex flex-col items-start justify-start overflow-auto">
      {/* Première colonne */}
      <div className="flex flex-col w-full pl-4 h-full ">
        <div className="text-hx font-medium text-left">Paiements</div>
        <Space y={10} />
        <div className=" flex flex-row justify-between items-center w-full  max-w-c1p3k">
          <div className="flex flex-col gap-2 w-full">
            {/* <SearchBarPayments
              orgData={orgData}
              options={options}
              setValue={setSearchValue}
              value={searchValue}
              onAction={() => {}}
            /> */}
            <SearchAlgolia
              options={algoliaResults.map((result) => ({
                label: result.nom,
                value: result.objectID,
                extra_label: result.email,
                extra_label_2: result.phone,
              }))}
              inputValue={searchValue}
              setInputValue={(value) => handleQuerySearch(value)}
              placeholder="Rechercher un paiement..."
              onAction={gotoPaymentName}
              classNameCustom="w-c600"
            ></SearchAlgolia>
            <Space y={10} />
            {searchValue === "" && (
              <div className="flex flex-row gap-2">
                <div className="ml-0 pl-0 left-0 relative">
                  <TabGPT
                    tabs={tabs}
                    activeTab={activetab}
                    setActiveTab={handleTabChange}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-col border-1  rounded-xl h-fit p-4 w-fit">
            <div className="flex flex-row ">
              {payments_per_month.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col  text-h5 w-c40 items-center"
                >
                  <div
                    className="bg-indigo-500 rounded-sm w-3 mt-auto mb-1 relative"
                    style={{
                      height: valueNanCheck(item.height),
                    }}
                  >
                    <div
                      className="absolute bottom-0 left-0 right-0 w-3"
                      style={{
                        height: valueNanCheck(item.bridge_height),
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                      }}
                    ></div>
                  </div>
                  <div className=" text-indigo-500 text-h4">
                    {item.count > 0 ? (
                      Math.round(item.count / 100) / 10 + "k"
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="text-h6 text-shadow_50">
                    {item.month.substring(0, 3)}
                  </div>{" "}
                </div>
              ))}
            </div>
          </div>
        </div>

        <Space y={10} />

        <div className="w-full pb-24 h-full max-h-full max-w-c1p3k  min-h-6   ">
          <DataGridGPT2
            rows={rows}
            selectable={false}
            columns={columns}
            onClick={(value) => {
              gotoPaymentName({
                value: value.id,
                label: value.nom,
              });
            }}
            initial_sort_field="date"
            initial_asc="desc"
            handleSelectionModelChange={handleSelectionModelChange}
          />
        </div>
      </div>
    </div>
  );
};
export default Payments;
